import { useState } from 'react';
import API from '../API';
import { useToast } from '../contexts/ToastContext';

const errorMessage = (error) =>
  error.response?.data?.message ||
  error.response?.data?.error ||
  error.message ||
  'Unknown error';

// Shared row-level actions for an organization (list + detail views).
// `onChanged` is awaited after a successful mutation so the caller can refresh.
export const useOrganizationActions = ({ onChanged } = {}) => {
  const { showToast } = useToast();
  const [busy, setBusy] = useState(false);

  const run = async (label, apiCall) => {
    setBusy(true);
    try {
      await apiCall();
      showToast(label);
      if (onChanged) await onChanged();
      return true;
    } catch (error) {
      showToast(`Something went wrong: ${errorMessage(error)}`, { type: 'error' });
      return false;
    } finally {
      setBusy(false);
    }
  };

  const setStatus = (organization, status) =>
    run(`${organization.name} is now ${status}`, () =>
      API.setOrganizationStatus(organization.id, status)
    );

  const createSupportUser = (organization) =>
    run(`Support user created for ${organization.name}`, () =>
      API.createSupportUser(organization.id)
    );

  return { busy, setStatus, createSupportUser };
};
